// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { SeoRepoService } from '../../../../services/seo-repo.service';
import { MonLoadingService } from '@monsido/services/loading/services/loading.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-with-duplicate-title-pages',
    templateUrl: './pages-with-duplicate-title-pages.component.html',
    standalone: false,
})
export class PagesWithDuplicateTitlePagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy, OnChanges {
    @Input() selectedTitle: any = null;
    @Input() issue: any;
    @Output() getTitles = new EventEmitter<void>();

    private destroy$ = new Subject<void>();
    loading = false;

    pages: any[] = [];
    promise: Promise<any> | null = null;
    eventId = 0;
    pageDetailsIsAvailable = false;

    constructor (
        private seoRepoService: SeoRepoService,
        private loadingService: MonLoadingService,
        private baseEntityService: BaseEntityService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');

        // Set up event listener for entity updates
        this.eventId = this.monEventsService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.pages = [];
        this.promise = null;

        if (this.selectedTitle !== null) {
            this.getPage();
        }
    }

    ngOnDestroy (): void {
        if (this.eventId) {
            this.monEventsService.remove(this.eventId);
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnChanges (): void {
        if (this.selectedTitle !== null) {
            this.getPage();
        }
    }

    override async getPage (): Promise<void> {
        if (!this.selectedTitle || !this.issue) {
            return;
        }

        this.loading = true;
        this.loadingService.show();

        try {
            const params = {
                issue_id: this.issue.id,
                page: this.page,
                page_size: this.pageSize,
                status: this.activeTab,
                search: this.activeTab === 'filtered' ? this.search : null,
                sort_by: this.currentSort.by,
                sort_dir: this.currentSort.direction,
                content: this.selectedTitle.title,
            };

            this.promise = this.seoRepoService.getSeoIssuePages(this.issue.id, params).then((data) => {
                this.pages = data;
                return data;
            }).catch(() => {
                // Handle error silently like original
            });

        } finally {
            this.loading = false;
            this.loadingService.hide();
        }
    }

    override onPageDetailsClose (): void {
        this.getTitles.emit();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
